/* lua.js generated code 0.3.1 */
PromotionManager = xClass("PromotionManager")

let _instance = null;
PromotionManager.getInstance = function () {
    if (!_instance)
        _instance = PromotionManager.create();
    return _instance;
}

PromotionManager.prototype.ctor = function () {
}

PromotionManager.prototype.getId = function () {
    return this.id
}

PromotionManager.prototype.getReward = function(){
    return this.rewardStr
}

PromotionManager.prototype.getBackUrl = function(){
    return this.backImage
}

PromotionManager.prototype.getBtnUrl = function(){
    return this.btnImage
}

PromotionManager.prototype.setCloseCb = function(cb){
    this.closeCb = cb
}

PromotionManager.prototype.initCfg = function () {
    //return Promise.resolve();
    let self = this
    return CfgManager.load("game").then((dataMap)=>{
          let gameCfg = dataMap.get('game')
          
          self.rewardStr = gameCfg.cg_promotion_reward
          self.backImage = gameCfg.cg_promotion_image
          self.btnImage = gameCfg.cg_promotion_btn
          self.id = gameCfg.cg_promotion_id

          CfgManager.release("game")
        }).catch(()=>{CfgManager.release("game")})
}

module.exports = PromotionManager
